<template>
  <div class="vmp-virtual">
    <vh-dialog
      :title="$t('host.k_542001')"
      :visible.sync="virtualVisible"
      :before-close="virtualClose"
      width="520px"
    >
      <div class="vmp-virtual-wrap">
        <div class="vmp-virtual-wrap-contaner">
          <div class="vmp-virtual-wrap-contaner-real">
            {{ $t('host.k_542002', { n: online }) }}
            <span style="color: #1a1a1a">｜</span>
            {{ virtualText }} {{ pv }}&nbsp;&nbsp;
            <vh-tooltip effect="dark" placement="right">
              <i class="vh-iconfont vh-line-question"></i>
              <div slot="content">
                {{ $t('host.k_542003') }}
                <br />
                2.{{ virtualText }}{{ $t('host.k_542004') }}
              </div>
            </vh-tooltip>
            <!-- <span class="view-notice" @click="viewNotice">查看注意事项</span> -->
          </div>
          <div class="vmp-virtual-wrap-contaner-online">
            <p class="vmp-virtual-wrap-contaner-online-num">
              <template>
                <span>{{ totalOnlineNum }}</span>
                {{ $t('host.k_542005') }}
                <span>{{ totalPv }}</span>
              </template>
            </p>
            <p v-if="addCount == 0" class="vmp-virtual-wrap-contaner-online-vir">
              {{ $t('host.k_542006') }}
              <!-- 暂未添加虚拟人数 -->
            </p>
            <!-- <p class="vmp-virtual-wrap-contaner-online-vir" v-else>
            已累计添加{{ addCount }}次虚拟人数
          </p> -->
          </div>
          <div class="vmp-virtual-wrap-contaner-form">
            <vh-form
              :label-width="$i18n.locale == 'en' ? '120px' : '70px'"
              :rules="virtualRules"
              :model="formInfo"
              ref="formInfo"
            >
              <vh-form-item :label="$t('host.k_542007')" prop="virtual_type">
                <vh-radio-group v-model="formInfo.virtual_type" @change="getVirtualSettings">
                  <vh-radio :label="1">{{ $t('host.k_542008') }}</vh-radio>
                  <vh-radio :label="2">{{ $t('host.k_542009') }}</vh-radio>
                  <!-- <vh-radio :label="5">指定显示数据</vh-radio>-->
                </vh-radio-group>
                <p class="vh-form-item-tips" v-if="formInfo.virtual_type == 1">
                  {{ $t('host.k_542010') }}
                </p>
                <p class="vh-form-item-tips" v-else-if="formInfo.virtual_type == 2">
                  {{ $t('host.k_542011') }}
                </p>
                <!-- <p class="vh-form-item-tips" v-else-if="formInfo.virtual_type == 5">
                观众端按照设置的数据直接显示，无需考虑实际数据
              </p> -->
              </vh-form-item>
              <template v-if="formInfo.virtual_type != 5">
                <vh-form-item
                  :label="$t('host.k_542012')"
                  v-if="formInfo.virtual_type == 2"
                  prop="timerange"
                >
                  <vh-date-picker
                    v-model="formInfo.timerange"
                    type="datetimerange"
                    :range-separator="$t('host.k_542013')"
                    format="yyyy-MM-dd HH:mm"
                    value-format="yyyy-MM-dd HH:mm"
                    :append-to-body="false"
                    :start-placeholder="$t('host.k_542014')"
                    :end-placeholder="$t('host.k_542015')"
                    :picker-options="{
                      disabledDate: disabledPastDate
                    }"
                  ></vh-date-picker>
                </vh-form-item>
                <vh-form-item key="addOnline" :label="$t('host.k_542016')" prop="addOnline">
                  <vh-input
                    :placeholder="$t('host.k_542017')"
                    type="number"
                    v-model="formInfo.addOnline"
                  >
                    <b slot="suffix">{{ $t('host.k_542018') }}</b>
                  </vh-input>
                </vh-form-item>
                <vh-form-item key="addPv" :label="$t('host.k_542019')" prop="addPv">
                  <vh-input
                    :placeholder="$t('host.k_542017')"
                    type="number"
                    v-model="formInfo.addPv"
                  >
                    <b slot="suffix">{{ $t('host.k_542020') }}</b>
                  </vh-input>
                </vh-form-item>
              </template>
              <template v-else>
                <vh-form-item key="online" :label="$t('host.k_542021')" prop="online">
                  <vh-input :placeholder="$t('host.k_542022')" v-model="formInfo.online"></vh-input>
                </vh-form-item>
                <vh-form-item key="pv" :label="$t('host.k_542023')" prop="pv">
                  <vh-input :placeholder="$t('host.k_542024')" v-model="formInfo.pv"></vh-input>
                </vh-form-item>
              </template>
            </vh-form>
          </div>
        </div>
        <div class="vmp-virtual-wrap-btn">
          <div class="vmp-virtual-wrap-btn-left"></div>
          <div class="vmp-virtual-wrap-btn-right">
            <vh-button
              v-if="formInfo.virtual_type == 2 && formInfo.status == 1"
              type="primary"
              round
              size="medium"
              @click="stopVirtualPeople"
            >
              {{ $t('host.k_542025') }}
            </vh-button>
            <vh-button type="primary" v-else round size="medium" @click="setVirtualPeople">
              {{ formInfo.virtual_type == 2 ? $t('host.k_542026') : $t('host.k_542027') }}
            </vh-button>
          </div>
        </div>
      </div>
    </vh-dialog>
  </div>
</template>
<script>
  import { useVirtualAudienceServer, useMsgServer } from 'middle-domain';
  import CountTo from './js/countTo';
  import regRule from '@/app-shared/utils/reg-rule.js';
  import { throttle } from 'lodash';
  export default {
    name: 'VmpVirtualPeople',
    data() {
      const validateTime = (rule, value, callback) => {
        if (!value || value.length < 2) {
          callback(new Error(this.$t('host.k_542028')));
        } else {
          callback();
        }
      };
      const validateAddOnline = (rule, value, callback) => {
        const re = regRule.positiveInt;
        if (!re.test(value) || value <= 0 || value > 999999) {
          return callback(new Error(this.$t('host.k_542029')));
        } else if (this.formInfo.addOnline > Number(this.formInfo.addPv)) {
          return callback(new Error(this.$t('host.k_542030')));
        } else {
          if (this.formInfo.addPv !== '') {
            this.$refs.formInfo.clearValidate('addPv');
          }
          callback();
        }
      };
      const validateAddPv = (rule, value, callback) => {
        const re = regRule.positiveInt;
        if (!re.test(value) || value <= 0 || value > 999999) {
          return callback(new Error(this.$t('host.k_542029')));
        } else if (this.formInfo.addOnline > Number(this.formInfo.addPv)) {
          return callback(new Error(this.$t('host.k_542031')));
        } else {
          if (this.formInfo.addOnline !== '') {
            this.$refs.formInfo.clearValidate('addOnline');
          }
          callback();
        }
      };
      const validateCount = (rule, value, callback) => {
        const re = regRule.positiveInt;
        value = Number(value);
        if (!re.test(value) || value <= 0 || value > 999999) {
          callback(new Error(this.$t('host.k_542032')));
        } else {
          callback();
        }
      };

      return {
        virtualVisible: false,
        webinarId: this.$route.params.id,
        addCount: 0,
        virtualText: this.$t('host.k_542033'),
        curVirtualType: 2,
        formInfo: {
          timerange: [],
          virtual_type: 2,
          time: '',
          online: '',
          addOnline: '',
          pv: '',
          addPv: '',
          status: 0, //分时任务1:进行中
          watchShow: false
        },
        virtualRules: {
          timerange: [{ validator: validateTime, trigger: 'change' }],
          online: [{ validator: validateCount, trigger: 'blur' }],
          pv: [{ validator: validateCount, trigger: 'blur' }],
          addOnline: [{ validator: validateAddOnline, trigger: 'blur' }],
          addPv: [{ validator: validateAddPv, trigger: 'blur' }]
        },
        setIntervalVirtual: null,
        onlineNumCountTo: new CountTo(),
        pvCountTo: new CountTo()
      };
    },
    beforeCreate() {
      this.virtualAudienceServer = useVirtualAudienceServer();
      this.msgServer = useMsgServer();
    },
    computed: {
      totalOnlineNum() {
        // 总在线人数（真实+虚拟）
        return this.curVirtualType == 5 ? this.virtualOnline : this.online + this.virtualOnline;
      },
      totalPv() {
        // 总观看人数/热度（真实+虚拟）
        return this.curVirtualType == 5 ? this.virtualPv : Number(this.pv + this.virtualPv);
      },
      online() {
        return Number(this.$domainStore.state.virtualAudienceServer.uvOnline);
      },
      virtualOnline() {
        return Number(this.$domainStore.state.virtualAudienceServer.virtualOnline);
      },
      pv() {
        return Number(this.$domainStore.state.virtualAudienceServer.uvHot);
      },
      virtualPv() {
        return Number(this.$domainStore.state.virtualAudienceServer.virtualHot);
      }
    },
    mounted() {
      this.msgServer.$onMsg('ROOM_MSG', this.handleVirtualSetMsg);
    },
    beforeDestroy() {
      clearInterval(this.setIntervalVirtual);
      this.msgServer.$offMsg('ROOM_MSG', this.handleVirtualSetMsg);
    },
    methods: {
      handleVirtualSetMsg(msg) {
        if (msg?.data?.type === 'virtual_set') {
          this.getVirtualSettings();
        }
      },
      disabledPastDate(time) {
        return time.getTime() < Date.now() - 8.64e7;
      },

      openVirtualDialog(info) {
        this.virtualVisible = true;
        this.virtualText = info.type == 1 ? this.$t('host.k_542033') : this.$t('host.k_542034');
        this.getVirtualSettings();
      },
      setVirtualPeople: throttle(
        function () {
          this.$refs.formInfo.validate(valid => {
            if (valid) {
              const online =
                this.formInfo.virtual_type == 5 ? this.formInfo.online : this.formInfo.addOnline;
              const pv = this.formInfo.virtual_type == 5 ? this.formInfo.pv : this.formInfo.addPv;
              this.virtualAudienceServer
                .virtualClientStart({
                  webinar_id: this.webinarId,
                  virtual_type: this.formInfo.virtual_type,
                  begin_time: this.formInfo.timerange[0],
                  end_time: this.formInfo.timerange[1],
                  online,
                  pv
                })
                .then(res => {
                  if (res.code == 200) {
                    this.curVirtualType = this.formInfo.virtual_type;
                    this.$message.success(this.$t('host.k_542035'));
                  } else {
                    this.$message.warning(res.msg);
                  }
                });
            } else {
              return false;
            }
          });
        },
        2000,
        { trailing: false }
      ),
      stopVirtualPeople: throttle(
        function () {
          this.virtualAudienceServer
            .virtualClientStop({
              webinar_id: this.webinarId
            })
            .then(res => {
              if (res.code == 200) {
                this.$vhMessage.success(this.$t('host.k_542036'));
              } else {
                this.$vhMessage.warning(res.msg);
              }
            });
        },
        2000,
        { trailing: false }
      ),
      getVirtualSettings(virtual_type) {
        this.virtualAudienceServer
          .getVirtualSettings({
            webinar_id: this.webinarId,
            virtual_type
          })
          .then(res => {
            const { virtual_type, begin_time, end_time, online, pv, status } = res.data;
            this.formInfo.virtual_type = virtual_type;
            this.curVirtualType = virtual_type;
            this.formInfo.timerange = !begin_time || !end_time ? [] : [begin_time, end_time];
            this.formInfo.status = status;
            if (virtual_type == 5) {
              this.formInfo.online = online;
              this.formInfo.pv = pv;
            } else {
              this.formInfo.addOnline = online || 80;
              this.formInfo.addPv = pv || 100;
            }
          });
      },

      virtualClose() {
        this.virtualVisible = false;
        this.$refs.formInfo.resetFields();
      }
      // viewNotice() {
      //   this.$vhAlert(
      //     `
      //   <p>1、立即生效和分时生效：设置后，结合直播间真实数据，进行数据的增加</p>
      //   <p>2、指定显示数据：设置后，观看端数据直接显示设置的数据；</p>
      //   <p>3、二者在使用过程中，不建议混合使用。假设直播间真实人数10人，热度100，设置「指定显示数据」为1000、2000后，观众端直接显示此数据。此时您在使用「添加虚拟数据」，那数据会直接下降明显，且按照实际人数进行增加，很容易发现数据造假</p>
      // `,
      //     '注意事项',
      //     {
      //       // 配置项
      //       dangerouslyUseHTMLString: true, // 允许内容解析HTML
      //       showConfirmButton: false,
      //       closeOnClickModal: false // 点击遮罩层不关闭弹窗
      //     }
      //   )
      //     .then(() => {})
      //     .catch(() => {});
      // }
    }
  };
</script>
<style lang="less" scoped>
  ::v-deep .vmp-virtual-wrap {
    &-contaner {
      &-real {
        color: @font-light-normal;
        font-size: 14px;
        span {
          color: @font-error-low;
        }
        .vh-iconfont {
          color: @font-light-low;
          font-size: 16px;
        }
        .view-notice {
          color: #0a7ff5;
          float: right;
          font-size: 14px;
          cursor: pointer;
        }
      }
      &-online {
        width: 300px;
        height: 92px;
        color: @font-light-normal;
        background: @bg-virtual;
        border-radius: 4px;
        border: 1px solid @border-virtual;
        text-align: center;
        margin-top: 10px;
        margin-left: 70px;
        &-num {
          font-size: 14px;
          padding-top: 18px;
          span {
            font-weight: 700;
            font-size: 24px;
          }
        }
        &-vir {
          margin-top: 9px;
          color: @font-light-low;
          font-size: 14px;
        }
      }
      &-form {
        width: 100%;
        font-size: 12px;
        padding-top: 16px;
        .vh-form-item__label {
          text-align: left;
        }
        .vh-form-item-tips {
          line-height: 20px;
          white-space: normal;
          word-break: break-word;
          overflow-wrap: break-word;
        }
      }

      .vh-date-editor--datetimerange.vh-input__inner {
        width: 100%;
      }
    }
    &-btn {
      display: flex;
      justify-content: space-between;
      align-items: center;
      // padding-bottom: 24px;
      &-left {
        span {
          padding-right: 10px;
        }
      }
      &-right {
        .virtual-stop {
          display: none;
        }
        &:hover {
          .virtual-stop {
            display: block;
          }
          .virtual-adding {
            display: none;
          }
        }
      }
    }
  }
</style>
